
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"321322e382b317ed3013c3dc766ecc50a682bfe8":"setRewardfulTokenAction","a1fdb61e20e062fabcd81827cbd39d3ce75a4a09":"$$ACTION_0"} */ export var setRewardfulTokenAction = createServerReference("321322e382b317ed3013c3dc766ecc50a682bfe8");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

